import { PlanDrawer, PlanPage } from './plan';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { ParameterValue, PlanParameters, PlanStage } from '@/types';

interface ProcessingProps {
  planStage: Record<string, string>;
  plan: PlanStage[];
  processedQuestion: string;
  loadingPlan: boolean;
  planEditable: boolean;
  loading: boolean;
  messages: string[];
  cancelPlan: () => void;
  setPlan: (plan: PlanStage[]) => void;
  executePlan: (plan: PlanStage[]) => void;
}

export function Processing({
  planStage,
  plan,
  loadingPlan,
  planEditable,
  setPlan,
  loading,
  messages,
  processedQuestion,
  cancelPlan,
  executePlan,
}: ProcessingProps) {
  const updatePlan = (plan: PlanStage[], step: number, parameterName: string, newValue: ParameterValue) => {
    // Get the plan step
    const planStep = plan[step];

    // Find the parameter
    const parameter = planStep.parameters.find((p) => p.name === parameterName);
    const index = planStep.parameters.findIndex((p) => p.name === parameterName);

    if (!parameter) return;

    // Set the parameter value to the new value
    const updatedParameter = { ...parameter, value: newValue, updated: true };

    // Update the plan
    planStep.parameters[index] = updatedParameter as PlanParameters;
    const newPlan = [...plan];
    newPlan[step] = planStep;

    // Add a mixpanel event
    trackCustomEvent(TrackingEvents.KimUpdatePlan, {
      fieldUpdated: parameterName,
    });

    setPlan(newPlan);
  };

  return (
    <div className="relative flex h-full w-full">
      <PlanDrawer
        planStage={planStage}
        plan={plan}
        loadingPlan={loadingPlan}
        executePlan={executePlan}
        executing={loading}
        editable={planEditable}
        updatePlan={updatePlan}
        cancelPlan={cancelPlan}
      />
      <PlanPage questionValue={processedQuestion} loading={loading} messages={messages} />
    </div>
  );
}
